export const bitWiseEquality = <T extends number>(subject: T, value: T): boolean => {
    if (subject === 0 || value === 0) {
        return subject == value;
    }
    return Boolean(subject & value);
};
